import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import Modal from 'flarum/common/components/Modal';

import LoadingIndicator from 'flarum/common/components/LoadingIndicator';

export default class VerfiyEmailModal extends Modal {
  // True by default, dictates whether the modal can be dismissed by clicking on the background or in the top right corner.
  static isDismissible = false;

  oninit(vnode) {
    super.oninit(vnode);
    this.processing = true;

    let searchParams = new URLSearchParams(window.location.search);
    this.uid = searchParams.get('uid');

    this.user = null;
    this.auth0_domain = '';

    let _this = this;
    app
      .request({
        method: 'POST',
        url: '/api/ui/get-user',
        body: { uid: this.uid },
      })
      .then(function (response) {
        _this.user = response.user;
        _this.auth0_domain = response.auth0_domain;
        _this.processing = false;
        m.redraw();
      })
      .catch(function (e) {});
  }

  className() {
    // Custom CSS classes to apply to the modal
    return 'Modal';
  }

  title() {
    // Content to show in the modal's title bar
    return <span>Verify email address</span>;
  }

  content() {
    if (this.processing) return LoadingIndicator.component();

    // Content to show in the modal's body
    return (
      <form onsubmit={this.onsubmit.bind(this)}>
        <div className="FormFieldWrap mb-2 px-2">
          <div>
            <div className="FormFieldWrap mt-2">
              <p>We have sent you a verification email.</p>
              <p>
                You need to verify your email address (<strong>{this.user.email}</strong>) to continue.
              </p>
              <p>Please click the button below to send a verification email if you haven't already received.</p>
            </div>
            <div className="FormFieldWrap mt-2">
              <div className="FormGroup d-flex justify-content-between flex-column">
                {this.processing ? (
                  LoadingIndicator.component()
                ) : (
                  <div>
                    <Button type="submit" className="Button" id="btn-send-verification-email" disabled={this.processing}>
                      Send me a new verification email
                    </Button>
                    <div className="mt-2">
                      Not using {this.user.email}?{' '}
                      <a href={`https://` + this.auth0_domain + `/v2/logout?returnTo=` + app.forum.attribute('baseUrl') + '/auth/auth0'}>
                        Use another account
                      </a>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  }

  createCookie(name, value, days) {
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      var expires = '; expires=' + date.toGMTString();
    } else var expires = '';
    document.cookie = name + '=' + value + expires + '; path=/';
  }

  onsubmit(e) {
    e.preventDefault();
    app.alerts.clear();
    let thisClass = this;
    app
      .request({
        method: 'POST',
        url: '/api/ui/send-verification-email',
        body: { uid: this.uid },
      })
      .then(function (response) {
        if (response.success) {
          app.alerts.show({ type: 'success' }, 'Verification email has been sent.');
          setTimeout(() => {
            window.close();
          }, 7 * 1000); // Enable after x seconds
        } else {
          app.alerts.show({ type: 'error' }, 'Something went wrong, please try again.');
        }
        thisClass.processing = false;
      })
      .catch(function (e) {
        thisClass.processing = false;
      });
  }
}
